import { gql } from 'apollo-boost'

import { TASK_VIEW_FIELDS } from '../fragments/task-view-fields'

const MENU_DEFINITION_TASK = gql`
  ${TASK_VIEW_FIELDS}
  query menuDefinitionTask($id: ID!) {
    menuDefinitionTask(id: $id) {
      id
      status
      isAwaiting
      isRerunFlow
      awaitingReason
      awaitingReasonComment
      modifiedDate
      reopenedDate
      reopenReason
      currentViewType

      brand {
        id
        name
        website
        status
        businessStatus
        exclusionReason
        menu {
          id
          url
          format
          additionalUrls
          availabilityComment
          isExample
          isSimpleMenu
          modifiedDate
          notScrapeableReason
          notScrapeableComment
        }
        locations {
          id
          name
          website
          status
          exclusionReason
          businessStatus
          menuStatus
          formattedAddress
          menu {
            id
            url
            format
            additionalUrls
            availabilityComment
            isExample
            isSimpleMenu
            modifiedDate
            notScrapeableReason
            notScrapeableComment
            menuScrapingClusterId
          }
        }
      }
      assignedTo {
        id
        name
      }
      reopenedBy {
        id
        name
      }
      modifiedDate

      miscTaskVerifiedBy {
        id
        name
      }
      miscTaskVerifiedDate
      miscTaskVerifiedComment

      miscTaskQCVerifiedBy {
        id
        name
      }
      miscTaskQCVerifiedDate
      miscTaskQCVerifiedComment
      isAssignable

      relatedTasks {
        brandId
        brandGatewayTask {
          id
          status
          isCurrentViewAutoResolved
        }
        brandDefinitionTask {
          id
          status
          isCurrentViewAutoResolved
        }
        menuDefinitionTask {
          id
          status
          isCurrentViewAutoResolved
        }
      }

      views {
        ...TaskViewFields
        modifiedLocationIdsUnreviewedByDefiner
      }
    }
  }
`

export default MENU_DEFINITION_TASK
